import {Field, Input, Label, Message} from "@zendeskgarden/react-forms";
import {ReactElement} from "react";

import * as css from "./styles/manualPropertyFormStyles.module.scss";

export interface IManualPropertyFormInput {
    label: string | ReactElement,
    placeholder: string | undefined,
    displayInput?: boolean,
    required: boolean,
    value: string | number | readonly string[] | undefined,
    message?: string | undefined,
    warning?: string | undefined,
    error: string | undefined,
    onChange: (evt: any) => void,
    onBlur: () => void,
}

export default function ManualPropertyFormInput(props: IManualPropertyFormInput): ReactElement {
    const {label, placeholder, displayInput = true, required, value, message, warning, error, onChange, onBlur} = props;

    return (
        <Field>
            <Label className={css.manualPropertyFormLabel}>
                {typeof label === "string" ? <span>{label}</span> : label}
                {
                    required && <span className={css.required}>REQUIRED</span>
                }
            </Label>
            {message && <Message>{message}</Message>}
            {displayInput &&
                <>
                    <Input
                        value={value}
                        onChange={onChange}
                        onBlur={onBlur}
                        placeholder={placeholder}
                        validation={error ? "error" : undefined}
                    />
                    {
                        warning &&
                        <Message validation="warning">{warning}</Message>
                    }
                    {
                        error &&
                        <Message validation="error">{error}</Message>
                    }
                </>
            }
        </Field>
    );
}